/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./searchActorsTypeahead.defs.js";
export { main as default } from "./searchActorsTypeahead.defs.js";
